import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './SendingAnimation.scss';

const SendingAnimation = ({
  success,
  error,
}) => (
  <svg viewBox="0 0 100 100" className={classNames({
    'sending-animation-progress': true,
    'sending-animation-progress-success': success,
    'sending-animation-progress-error': error,
  })}>
    <defs>
      <pattern id="check" width="100%" height="100%" viewBox="0,0,512,512">
        <path d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0
          c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7
          C514.5,101.703,514.499,85.494,504.502,75.496z" />
      </pattern>
      <pattern id="cross" width="100%" height="100%" viewBox="0,0,31.112,31.112">
        <polygon points="31.112,1.414 29.698,0 15.556,14.142 1.414,0 0,1.414 14.142,15.556 0,29.698 1.414,31.112 15.556,16.97 29.698,31.112 31.112,29.698 16.97,15.556 "/>
      </pattern>
    </defs>
    <circle
      cx="50"
      cy="50"
      r="48"
      fill="transparent"
      className="progress-circles"
      strokeDasharray="302 0"
      strokeDashoffset="0"
      strokeWidth="3"
      stroke="black"
    />
    <circle
      cy="50"
      cx="50"
      r="20"
      className="check-mark"
      fill="url(#check)"
    />
    <circle
      cy="50"
      cx="50"
      r="20"
      className="cross-mark"
      fill="url(#cross)"
    />
  </svg>
);

SendingAnimation.propTypes = {
  success: PropTypes.bool,
  error: PropTypes.bool,
};

SendingAnimation.defaultProps = {
  success: false,
  error: false,
};

export default SendingAnimation;
